import type { RHFGroupFieldValue } from '@/components/dynamic-filter/FilterFormGroup';
import type { TaskCheckResponse } from '@/types/apps/task-check.type';
import type { GqlListResponse } from '@/types/common/api.type';
import { BaseService } from '@/types/service/graphql-service.type';

export interface TaskCheckServiceInterface {
    getFields(): Record<string, any>;
    getEntityName(): string;
}

type TaskCheckListResponse = GqlListResponse<TaskCheckResponse>;

export class TaskCheckGraphQLService
    extends BaseService
    implements TaskCheckServiceInterface
{
    public getEntityName(): string {
        return 'taskCheck';
    }

    public getFields(): Record<string, any> {
        return {
            createdDate: true,
            deviceId: true,
            device: {
                name: true,
                id: true,
                serialNumber: true,
            },
            taskCheckStatus: true,
            id: true,
            name: true,
            scheduledTime: true,
            assigneeName: true,
            assigneeId: true,
            code: true,
            ticket: {
                id: true,
                customer: {
                    id: true,
                    email: true,
                    name: true,
                    code: true,
                },
                code: true,
                name: true,
            },
            taskCheckType: {
                name: true,
                id: true,
            },
            taskProcessType: true,
            isLateTaskCheck: true,
            reminderScheduleTaskChecks: {
                reminderSchedule: {
                    createdBy: true,
                    createdDate: true,
                    deletedAt: true,
                    deletedBy: true,
                    deviceId: true,
                    endDate: true,
                    id: true,
                    installationDate: true,
                    isDeleted: true,
                    isFilterHead: true,
                    lastMaintenanceDate: true,
                    maintenanceCycle: true,
                    modifiedBy: true,
                    modifiedDate: true,
                    name: true,
                    nextMaintenanceDate: true,
                    partDetailId: true,
                    reminderAdvanceDays: true,
                    serialNumber: true,
                    timestampId: true,
                    type: true,
                    unitMaintenanceCycle: true,
                },
            },
        };
    }

    public async index(query: string): Promise<TaskCheckListResponse> {
        return this.fetchGqlList(query, this.getEntityName()).then(res => {
            res.items.forEach((item: TaskCheckResponse) => {
                item.customName = this.formatResponse(item);
            });

            return res;
        });
    }

    private formatResponse(data: TaskCheckResponse): string {
        return `${data?.code} - ${data?.name}`;
    }

    public getFilterByRole(): Record<string, RHFGroupFieldValue> {
        if (!this.getQueryById() || !this.getRoleTypeManager().getQuery) {
            return {};
        }

        return this.getRoleTypeManager().getQuery('task', {
            userId: this.getQueryById(),
        });
    }
}
